import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LeftOutlined } from '@ant-design/icons';
import { CURRENCY_FORMAT } from '@common/constants';
import { ColorModel } from '@common/models';
import ImageViewer from '@components/ui/image-viewer/image-viewer';

import './price-bubble-button.scss';

interface PriceBubbleButtonProps {
    color?: ColorModel;
    price: number;
    showMinimumWarning: boolean;
    onClick?: () => void;
}

const PriceBubbleButton = ({ color, price, showMinimumWarning, onClick }: PriceBubbleButtonProps): JSX.Element => {
    const [isHovering, setIsHovering] = useState<boolean>(false);
    const { t } = useTranslation();

    const hasColorAndIsHovering = color && isHovering;

    return (
        <div
            className="PriceBubbleButton"
            onMouseEnter={() => {
                setIsHovering(true);
            }}
            onMouseLeave={() => {
                setIsHovering(false);
            }}
        >
            <div className="PriceBubbleButton__container" onClick={onClick}>
                <LeftOutlined />
                <label className="PriceBubbleButton__price-label">
                    {CURRENCY_FORMAT.format(price)} {showMinimumWarning && price > 0 ? '*' : ''}
                </label>
                {hasColorAndIsHovering ? (
                    <label className="PriceBubbleButton__price-details">{t('PRICING_AREA.OPEN_DETAILS')}</label>
                ) : (
                    <ImageViewer selectedColor={color} className="image-viewer--thumbnail" />
                )}
            </div>

            {hasColorAndIsHovering ? <ImageViewer selectedColor={color} className="image-viewer" /> : null}
        </div>
    );
};

export default PriceBubbleButton;
